export const Rollbar: any = (window as any).Rollbar;
